import React, { createContext, useContext, useState, useEffect} from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    sessionStorage.getItem("isAuthenticated") === "true"
  );
  const [role, setRole] = useState(sessionStorage.getItem("role") || "");
  const [username, setUsername] = useState(sessionStorage.getItem("username") || "");
  const [token, setToken] = useState(sessionStorage.getItem("token") || "");

  // Keep state synced with sessionStorage (in case of manual reload)
  useEffect(() => {
    if (isAuthenticated && token) {
      sessionStorage.setItem("isAuthenticated", "true");
      sessionStorage.setItem("role", role);
      sessionStorage.setItem("username", username);
      sessionStorage.setItem("token", token);
    }
  }, [isAuthenticated, role, username, token]);

  const login = (role, username, token) => {
    setIsAuthenticated(true);
    setRole(role);
    setUsername(username);
    setToken(token);
    sessionStorage.setItem("isAuthenticated", "true");
    sessionStorage.setItem("role", role);
    sessionStorage.setItem("username", username);
    sessionStorage.setItem("token", token);
  };

  const logout = () => {
    setIsAuthenticated(false);
    setRole("");
    setUsername("");
    setToken("");
    sessionStorage.clear();
  };

   // Helper to get auth headers easily
  const getAuthHeaders = () => {
    if (!token) return {};
    return { Authorization: `Bearer ${token}` };
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, role, username, token, login, logout, getAuthHeaders,}}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
